// Rewrites a Supabase Storage public URL to its image-transform endpoint.
// Returns the URL unchanged if it isn't a Supabase storage URL or is already transformed.
export function getThumbnailUrl(
  url: string | null | undefined,
  width = 600,
  quality = 70,
): string {
  if (!url) return "";
  if (!url.includes("/storage/v1/object/public/")) return url;
  if (url.includes("/render/image/public/")) return url;
  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/",
  );
  const sep = transformed.includes("?") ? "&" : "?";
  return `${transformed}${sep}width=${width}&quality=${quality}&resize=contain`;
}
